<div class="card">
    <div class="card-body">
        <h5 class="card-title">{{ 'risks.cardTitle' | t }}</h5>
        <h6 class="card-subtitle mb-2 text-muted">{{ 'selectExportTypeBelow' | t }}</h6>

        <hr />

        <button class="btn btn-default me-2 mb-2" (click)="download(ExportType.Risks)">
            {{ 'risks.risksButton' | t }}
        </button>
        @if (permService.permissions.HasRiskControlExportAccess) {
            <button class="btn btn-default me-2 mb-2" (click)="download(ExportType.RisksControls)">
                {{ 'risks.risksControlsButton' | t }}
            </button>
            <button
                class="btn btn-default me-2 mb-2"
                (click)="download(ExportType.RiskControlMois)"
            >
                {{ 'risks.risksControlsMoisButton' | t }}
            </button>
            <button
                class="btn btn-default me-2 mb-2"
                (click)="exportRiskAssessmentPerOrganization()"
            >
                {{ 'risks.riskAssessmentButton' | t }}
            </button>
        }
        @if (permService.permissions.IsDeveloperAdmin) {
            <hr />

            <mat-checkbox color="primary" name="includeArchivedLinks" [(ngModel)]="includearchivedlinks"
                >{{ 'includeArchivedLinksCheckbox' | t }}</mat-checkbox
            >
            <hr />

            <button
            class="btn btn-default me-2 mb-2"
            (click)="downloadRiskForImport()"
            >
                {{ 'risks.riskExportForImportButton' | t }}
            </button>
        }
    </div>
</div>
